import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import ContentPasteOutlinedIcon from '@mui/icons-material/ContentPasteOutlined';
import GuideCallout, { GuideCalloutOption } from '../shared/GuideCallout';
import HistoryBookIcon from '../icons/HistoryBookIcon';
import { PASTE_ACTION } from '../shared/SheetPaste';

/**
 * Speech-bubble guide for a new user's empty portfolio on the Risk Overview.
 * It points at the portfolio imports button in the top bar and offers the
 * ways to bring in holdings: a file upload, Paste from Excel (when `onPaste`
 * is given) or picking Watchlist securities.
 */
export default function PortfolioGetStartedCallout({
    open,
    anchorEl,
    onUpload,
    onPaste = null,
    onPickFromWatchlist = null,
    onDismiss,
}) {
    return (
        <GuideCallout
            open={open}
            anchorEl={anchorEl}
            ariaLabel="Import your portfolio"
            title="Import your portfolio"
            subtitle="Pick a way to bring in your holdings — portfolio imports are up here."
            onDismiss={onDismiss}
        >
            <Box sx={{ display: 'grid', gap: 0.25 }}>
                <GuideCalloutOption
                    icon={<HistoryBookIcon sx={{ fontSize: 20 }} />}
                    label="Upload a portfolio file"
                    detail="Import a holdings spreadsheet"
                    onClick={onUpload}
                />
                {onPaste && (
                    <GuideCalloutOption
                        icon={<ContentPasteOutlinedIcon sx={{ fontSize: 20 }} />}
                        label="Paste from Excel"
                        detail={`Copy your holdings with their header row, then ${PASTE_ACTION}`}
                        onClick={onPaste}
                    />
                )}
                {onPickFromWatchlist && (
                    <GuideCalloutOption
                        icon={<AddIcon sx={{ fontSize: 20 }} />}
                        label="Pick from your Watchlist"
                        detail="Select the securities you hold and enter shares"
                        onClick={onPickFromWatchlist}
                    />
                )}
            </Box>
        </GuideCallout>
    );
}

PortfolioGetStartedCallout.propTypes = {
    open: PropTypes.bool.isRequired,
    anchorEl: PropTypes.object,
    onUpload: PropTypes.func.isRequired,
    onPaste: PropTypes.func,
    onPickFromWatchlist: PropTypes.func,
    onDismiss: PropTypes.func.isRequired,
};
